import React from 'react'
import { BaseQuestion } from '../../../types/end-journey'

interface BaseQuestionLayoutProps {
  question: BaseQuestion
  children: React.ReactNode
  error?: string
}

export const BaseQuestionLayout: React.FC<BaseQuestionLayoutProps> = ({
  question,
  children,
  error,
}) => {
  return (
    <div className="w-full max-w-2xl mx-auto px-4 sm:px-6 pt-8 sm:pt-16 pb-2">
      <div className="space-y-2 mb-4 sm:mb-6">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
          {question.title}
          {!question.optional && <span className="text-red-500 ml-1">*</span>}
        </h2>
        {question.description && (
          <p
            className="text-xs sm:text-sm text-gray-600"
            dangerouslySetInnerHTML={{
              __html: question.description.replace(/\\n/g, '<br/>'),
            }}
          />
        )}
      </div>

      <div>{children}</div>

      {error && <p className="text-xs sm:text-sm text-red-500 mt-2">{error}</p>}
    </div>
  )
}
